import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import PlaceService from "services/PlaceService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getPlaceDetailApi = createAsyncThunk(
    "news/detail",
    async (data, { rejectWithValue }) => {
        try {
            const response = await PlaceService.getPlaceDetail(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const getPlaceApi = createAsyncThunk(
    "place/getPlaceApi",
    async (data, { rejectWithValue }) => {
        try {
            const response = await PlaceService.getListPlace(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const getPlaceById = createAsyncThunk(
    "place/getPlaceById",
    async (id, { rejectWithValue }) => {
        try {
            const response = await PlaceService.getPlaceById(id);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const addPlaceApi = createAsyncThunk(
    "place/addPlaceApi",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await PlaceService.createPlace(payload);
            if (onSuccess) onSuccess(response);
            openNotification(
                "success",
                Utils.setLocale("admin.settings.popup.notification.success"),
                Utils.setLocale("admin.settings.popup.notification.title")
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const updatePlaceApi = createAsyncThunk(
    "place/updatePlaceApi",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await PlaceService.updatePlace(payload);
            if (onSuccess) onSuccess(response);
            openNotification(
                "success",
                Utils.setLocale("admin.settings.popup.notification.success"),
                Utils.setLocale("admin.settings.popup.notification.title")
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const delPlaceApi = createAsyncThunk(
    "place/delPlaceApi",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess, id } = data;
            const response = await PlaceService.delPlace(id);
            if (onSuccess) onSuccess(response);
            openNotification(
                "success",
                Utils.setLocale("admin.settings.popup.notification.success"),
                Utils.setLocale("admin.settings.popup.notification.title")
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const changePlaceStatus = createAsyncThunk(
    "place/changePlaceStatus",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess } = data;
            const response = await PlaceService.changePlaceStatus(data);
            openNotification(
                "success",
                Utils.setLocale("admin.settings.popup.notification.success"),
                Utils.setLocale("admin.settings.popup.notification.title")
            );
            if (onSuccess) onSuccess(response);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

const initialState = {
    loading: false,
    placeList: [],
    placeDetail: {},
};
export const placeSlice = createSlice({
    name: "place",
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true;
        },
        setPlaceDetail: (state) => {
            state.loading = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPlaceApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPlaceApi.fulfilled, (state, action) => {
                state.loading = false;
                state.placeList = action.payload;
            })
            .addCase(getPlaceApi.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(getPlaceById.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPlaceById.fulfilled, (state, action) => {
                state.loading = false;
                state.placeDetail = action.payload;
            })
            .addCase(getPlaceById.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(addPlaceApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(addPlaceApi.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addPlaceApi.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(updatePlaceApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(updatePlaceApi.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(updatePlaceApi.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(delPlaceApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(delPlaceApi.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(delPlaceApi.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(getPlaceDetailApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPlaceDetailApi.fulfilled, (state, action) => {
                state.loading = false;
                state.placeDetail = action.payload;
            })
            .addCase(getPlaceDetailApi.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(changePlaceStatus.pending, (state) => {
                state.loading = true;
            })
            .addCase(changePlaceStatus.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(changePlaceStatus.rejected, (state, action) => {
                state.loading = false;
            });;

    },
});

export const { showLoading, setPlaceDetail } = placeSlice.actions;

export default placeSlice.reducer;